import {Column} from '../shared/models/column';
import {ColumnType} from '../shared/enums/column-type.enum';
import { MobileSession } from '../mobile_sessions/mobile_session';

export class MobileActivity {
  // allColumns for DataTable
  static allColumns: Column[] = [
    new Column({name: '#', prop: 'id', type: ColumnType.Number, standard: true}),
    new Column({name: 'Aktion', prop: 'action', type: ColumnType.String, standard: true}),
    new Column({name: 'Daten', prop: 'data', type: ColumnType.String, standard: true}),
    new Column({name: 'Erstellt am', prop: 'created_at', type: ColumnType.DateTime, standard: true}),
    new Column({name: 'Gelöscht am', prop: 'deleted_at', type: ColumnType.DateTime, standard: true}),
    // Associated Columns
    new Column({name: 'Mobile Session', prop: 'mobile_session', association: 'belongs_to', columns: MobileSession.allColumns}),
  ];

  // Simple Columns
  id: number;
  mobile_session_id: number;
  action: string;
  data: string;
  created_at: boolean;
  deleted_at: boolean;
  // Associations
  mobile_session: MobileSession;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  humanize() {
    return this.mobile_session_id;
  }
}

export class MobileActivityList {
  count: number;
  data: MobileActivity[];

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
